import { Alert, Button, Stack, Typography } from '@mui/material';
import { CenteredFormPage } from 'components/CenteredFormPage';
import { PasswordChecklist } from 'components/shared/PasswordChecklist';
import { PasswordField } from 'components/shared/PasswordField';
import { observer } from 'mobx-react-lite';
import { KeyboardEvent } from 'react';
import { useRootStore } from 'stores/RootStore';

const ResetPasswordPage = observer(() => {
  const { routeStore, resetPasswordStore } = useRootStore();
  const { navigateByName } = routeStore;
  const { form, message, status, resetPassword } = resetPasswordStore;
  const newPasswordField = form.$('newPassword');

  const handleKeyInField = (evt: KeyboardEvent) => {
    if (evt.key === 'Enter') {
      evt.stopPropagation();
      evt.preventDefault();
      if (form.isValid) {
        resetPassword();
      }
    }
  };

  return (
    <CenteredFormPage aria-label="forgot password page">
      <form autoComplete="off">
        <Stack spacing={4}>
          <Typography variant="h5" textAlign="center">
            <strong>Change Password</strong>
          </Typography>
          {status === 'success' ? (
            <>
              <Typography variant="body1" textAlign="center">
                Your password has been changed.
              </Typography>
              <Button
                variant="contained"
                disableElevation
                style={{ height: 56 }}
                onClick={() => navigateByName('login')}
              >
                Back to Log In
              </Button>
            </>
          ) : (
            <>
              {message && (
                <Alert aria-label="form-error" severity={status === 'error' ? 'error' : 'success'}>
                  {message}
                </Alert>
              )}
              <Stack spacing={2}>
                <PasswordField
                  variant="outlined"
                  autoComplete="new-password"
                  onKeyDown={handleKeyInField}
                  data-testid="newPassword"
                  {...newPasswordField.bind()}
                  inputProps={{
                    role: 'textbox',
                  }}
                />
                <PasswordChecklist password={newPasswordField.value} />
              </Stack>

              <Button
                variant="contained"
                disableElevation
                style={{ height: 56 }}
                disabled={!form.isValid}
                onClick={() => resetPassword()}
              >
                Change Password
              </Button>
            </>
          )}
        </Stack>
      </form>
    </CenteredFormPage>
  );
});

export { ResetPasswordPage };
